import React, { FC, useEffect, useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import ExploreHseContextsNew from './exploreHseContextsNew';
import useExternalOrganization from "./useExternalOrganization";
import { LinkTo } from "shared/constants/linkTo";
import { AppTester } from "../../../supporting";
import useQuery from "shared/hooks/useQuery";
import { LMSActions } from "../../reducers/LMSSlice";
import { merge } from "shared/helpers/utils/filters";

const ExploreHseContextsExternal: FC<{ context?: string, overrideTeamProps?: any }> = ({ context, overrideTeamProps }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const isMediiia = AppTester.isMediiia();
  const isBrnd = AppTester.isBrnd()
  const params = useQuery()

  const { tab: brndTab, lang } = params || {}

  // useEffect(() => {
  //   dispatch(LMSActions.setDisciplinesLoading(true))
  // }, [context])

  if (location.pathname.startsWith(LinkTo.hseColl))
    history.replace('/teams/hsecolab');
  else if (location.pathname.startsWith(LinkTo.hseIll))
    history.replace('/teams/hseillustration');
  else if (location.pathname.startsWith(LinkTo.hseGal))
    history.replace('/teams/hsegallery');
  else if (location.pathname.startsWith(LinkTo.hseCGLAB))
    history.replace('/teams/hsecglab');
  else if (location.pathname.startsWith(LinkTo.hseLab))
    history.replace('/teams/hselab');
  else if (location.pathname.startsWith(LinkTo.hseSound))
    history.replace('/teams/hsesound');
  else if (location.pathname.startsWith(LinkTo.hseStartup) && context !== 'brnd' && !isBrnd)
    history.replace('/teams/hsestartup');
  else if (location.pathname.startsWith(LinkTo.hseBooks) && !isMediiia && !AppTester.isBooksGallllery())
    history.replace('/teams/hsepublishinghouse');

  // else if (location.pathname.startsWith(LinkTo.hseVS))
  //   history.replace('/teams/hsevisualresearch');

  const { teamName } = useParams<{ teamName: string }>();

  const team: any = useExternalOrganization(context || teamName, undefined, undefined, true);

  const env = process.env.REACT_APP_API_CONNECTION_MODE;

  if (context === 'brnd' && !brndTab && !location.pathname.includes('startup') && env !== 'develop') {
    let redirectTo = ''
    switch (env) {
      // case 'develop':
      //   redirectTo = 'https://shop-brnd-ru.burgdev.ru/?page=1'
      //   break
      case 'staging':
        redirectTo = 'https://shop-brnd-ru.burgstg.ru/?page=1'
        break
      case 'production':
        redirectTo = 'https://shop.brnd.ru/?page=1'
        break
    }
    window.location.href = redirectTo + `${lang ? '&lang=ru' : ''}`
    return null
  }

  const modifiedTeam = useMemo(() => {
    if (!team) return null;
    if (overrideTeamProps) {
      const mainFilter = merge(team?.mainFilter, overrideTeamProps?.mainFilter)
      //todo вынести фильтрацию в отдельную функцию и сделать опциональной
      mainFilter.exceptedTagIds = mainFilter.exceptedTagIds.filter((tagId: string) => {
        return !(mainFilter.requiredTagIds.includes(tagId));
      })
      
      return {
        ...team,
        ...overrideTeamProps,
        mainFilter
      }
    }
    return team
  }, [team, overrideTeamProps])

  if (!team || !([context, teamName].includes(team?.contextName) || [context, teamName].includes(team?.teamId))) {
    return null;
  }

  return <ExploreHseContextsNew team={modifiedTeam} />
}

export default ExploreHseContextsExternal;import React, { FC, useEffect, useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import ExploreHseContextsNew from './exploreHseContextsNew';
import useExternalOrganization from "./useExternalOrganization";
import { LinkTo } from "shared/constants/linkTo";
import { AppTester } from "../../../supporting";
import useQuery from "shared/hooks/useQuery";
import { LMSActions } from "../../reducers/LMSSlice";
import { merge } from "shared/helpers/utils/filters";

const ExploreHseContextsExternal: FC<{ context?: string, overrideTeamProps?: any }> = ({ context, overrideTeamProps }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const isMediiia = AppTester.isMediiia();
  const isBrnd = AppTester.isBrnd()
  const params = useQuery()

  const { tab: brndTab, lang } = params || {}

  // useEffect(() => {
  //   dispatch(LMSActions.setDisciplinesLoading(true))
  // }, [context])

  if (location.pathname.startsWith(LinkTo.hseColl))
    history.replace('/teams/hsecolab');
  else if (location.pathname.startsWith(LinkTo.hseIll))
    history.replace('/teams/hseillustration');
  else if (location.pathname.startsWith(LinkTo.hseGal))
    history.replace('/teams/hsegallery');
  else if (location.pathname.startsWith(LinkTo.hseCGLAB))
    history.replace('/teams/hsecglab');
  else if (location.pathname.startsWith(LinkTo.hseLab))
    history.replace('/teams/hselab');
  else if (location.pathname.startsWith(LinkTo.hseSound))
    history.replace('/teams/hsesound');
  else if (location.pathname.startsWith(LinkTo.hseStartup) && context !== 'brnd' && !isBrnd)
    history.replace('/teams/hsestartup');
  else if (location.pathname.startsWith(LinkTo.hseBooks) && !isMediiia && !AppTester.isBooksGallllery())
    history.replace('/teams/hsepublishinghouse');

  // else if (location.pathname.startsWith(LinkTo.hseVS))
  //   history.replace('/teams/hsevisualresearch');

  const { teamName } = useParams<{ teamName: string }>();

  const team: any = useExternalOrganization(context || teamName, undefined, undefined, true);

  const env = process.env.REACT_APP_API_CONNECTION_MODE;

  if (context === 'brnd' && !brndTab && !location.pathname.includes('startup') && env !== 'develop') {
    let redirectTo = ''
    switch (env) {
      // case 'develop':
      //   redirectTo = 'https://shop-brnd-ru.burgdev.ru/?page=1'
      //   break
      case 'staging':
        redirectTo = 'https://shop-brnd-ru.burgstg.ru/?page=1'
        break
      case 'production':
        redirectTo = 'https://shop.brnd.ru/?page=1'
        break
    }
    window.location.href = redirectTo + `${lang ? '&lang=ru' : ''}`
    return null
  }

  const modifiedTeam = useMemo(() => {
    if (!team) return null;
    if (overrideTeamProps) {
      const mainFilter = merge(team?.mainFilter, overrideTeamProps?.mainFilter)
      //todo вынести фильтрацию в отдельную функцию и сделать опциональной
      mainFilter.exceptedTagIds = mainFilter.exceptedTagIds.filter((tagId: string) => {
        return !(mainFilter.requiredTagIds.includes(tagId));
      })
      
      return {
        ...team,
        ...overrideTeamProps,
        mainFilter
      }
    }
    return team
  }, [team, overrideTeamProps])

  if (!team || !([context, teamName].includes(team?.contextName) || [context, teamName].includes(team?.teamId))) {
    return null;
  }

  return <ExploreHseContextsNew team={modifiedTeam} />
}

export default ExploreHseContextsExternal;